import { Vector3 } from '@technology/web3d';
import {
  NavigationalCapabilityBase,
  StationsNavigationCapability,
} from '@trimble/web3d-capabilities';

/**
 * Offers a station-marker pick to the navigation mode that currently owns the
 * viewer, so an unrelated mode is not torn down by station navigation
 * activating (NUMARK-1107, NUMARK-1128). Station navigation itself is excluded
 * so a pick while it is active still selects the clicked station.
 *
 * Returns true when the active mode consumed the position.
 */
export function offerStationPickToActiveNavigation(
  activeNavigation: NavigationalCapabilityBase | undefined,
  stationNavigation: StationsNavigationCapability,
  position: Vector3
): boolean {
  return (
    activeNavigation != null &&
    activeNavigation !== stationNavigation &&
    activeNavigation.tryNavigateToWorldPosition(position)
  );
}
